import { Input } from 'antd';
import React, { useState } from "react";
import { useUpdateProfileMutation } from '../../../store/appSlice';
import { useAppSelector } from '../../../store/store';
import ModalContainer from "../../ModalContainer";
import HeaderModalText from '../../HeaderModalText';
import VideoRecorderComponent from '../../VideoRecorderComponent';
import SubHeaderText from '../../SubText';
import { isEmpty } from 'lodash';

const{TextArea}=Input 

function SummaryModal({data,onEditSave,isVisible,onClose}) {
const[summaryText,setSummaryText]=useState(data?.aboutData??"")
const[summaryTextError,setSummaryTextError]=useState("")
const[videoUrl,setVideoUrl]=useState(data?.videoUrl??null)
const [updateProfile] = useUpdateProfileMutation()
const { user } = useAppSelector((state) => state["user"]);


const handleOnChange=(e)=>{
    setSummaryText(e.target.value) 
}

const onSaveAboutYou=()=>{
  setSummaryTextError("")
if(!isEmpty(summaryText)){

  const payload = {
    aboutYou:summaryText,
    video:videoUrl,
    param: user?.id,
  };
 
  updateProfile(payload)
    .unwrap()
    .then((incomingData) => { 
      onEditSave({aboutData:summaryText,videoUrl:videoUrl})
      onClose()
    }).
    catch((err)=>{
      
    })
  }
  else{
    setSummaryTextError('Summary cannot be empty')
  }
}


const asterikSign = () => (
  <h2
    style={{
      color: "red",
      fontSize: "20px",
      marginLeft: "5px",
      height:20
    }}
  >
    {" "}
    *
  </h2>
);


const errorSec = (err) => (
  <div style={{ marginBottom: "20px" }}>
    <text style={{ color: "red" }}>{err}</text>
  </div>
);

  return (
<ModalContainer onClose={onClose} onBtnClick={onSaveAboutYou} isVisible={isVisible}
modalHeaderText={"Profile"}
modalSubHeaderText={"Your Summary"}
>
    
    <div style={{flex:1}}> 
        <div style={{display:'flex',alignItems:'center',flexDirection:'row'}}>
<HeaderModalText text={'Summary'}/>
{asterikSign()}
</div>
        <TextArea
    value={summaryText}
    onChange={handleOnChange}
    style={{width:"100%", height: 120,resize: 'none'}}
    maxLength={400}
    status={`${summaryTextError?"error":""}`}

  
  />
  {!isEmpty(summaryTextError) && errorSec(summaryTextError)}

      </div>

      <div style={{flex:1,marginTop:20}}> 
      <div style={{flex:1,display:'flex',flexDirection:'column'}}>
<HeaderModalText text={'Introductory Video'}/>
<div style={{marginTop:5}}>
<SubHeaderText text={'Boost your hiring chances,upload a quick 25-30s intro video. It makes a difference!'}/>
</div>
</div>
<div style={{marginLeft:30,marginTop:10}}>
    <VideoRecorderComponent onSelectVideo={(data)=>{setVideoUrl(data)}} isEdit={true} incomingVideoUrl={data?.videoUrl}/>
    </div>
    </div>


    </ModalContainer>
   
  );
}

export default SummaryModal;
